export default {
  GENERIC: {
    REQUIRED: 'Required'
  },
  ZIP5: {
    REQUIRED: 'Zip Code is Required',
    MIN: 'Please Enter a Valid Zip Code'
  }
};
